import type { FunctionComponent } from 'react';

import Logo from '@/assets/icons/abb-logo.svg';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { LoadingIndicator } from '@/ui-components/loading-indicator/loading-indicator';

export const BackdropLoading: FunctionComponent = () => {
  return (
    <div className='fixed top-0 left-0 right-0 bottom-0 bg-white dark:bg-bg_dark z-50 '>
      <Flexbox justify='center' items='center' className='h-full gap-2'>
        <LoadingIndicator sizing='large' color='primary' />
        <Logo />
      </Flexbox>
    </div>
  );
};
